import { SELECTE_FEATURE, UNSELECTE_FEATURE } from '../actions/selectedFeatureActions';

const initialState = {
  selected: false,
  layer_id: '',
  feature: {},
  backSection: 'direction',
};

const selectedFeatureReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTE_FEATURE: 
      return {...state, selected: true, feature: action.feature, layer_id: action.layer_feature_id, backSection: action.backSection};
    case UNSELECTE_FEATURE: 
      return {...state, selected: false, feature: {}, type_geometry: '', layer_id: ''};
    default: return state;
  }
};

export default selectedFeatureReducer;
